import https from "../../configs/axios.config";
import { API_ROUTES } from "../../constants/API_ROUTES";

export const managerService = {
  get_all_staff: async (page = 1, limit = 10, search = "", token) => {
    const params = new URLSearchParams({ search_value: search }).toString();

    const response = await https.get(
      `${API_ROUTES.MANAGER.GET_ALL_STAFF}?page=${page}&limit=${limit}&${params}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
  get_staff_by_id: async (staff_id, token) => {
    const response = await https.get(
      `${API_ROUTES.MANAGER.GET_STAFF_BY_ID}/${staff_id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
  delete_staff: async (staff_id, token) => {
    const response = await https.delete(
      `${API_ROUTES.MANAGER.DELETE_STAFF}/${staff_id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
  create_user: (formData, token) => {
    const uri = API_ROUTES.MANAGER.CREATE_STAFF;
    return https.post(uri, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
  },
  update_user: (formData, staff_id, token) => {
    const uri = `${API_ROUTES.MANAGER.UPDATE_INFO_STAFF}/${staff_id}`;
    return https.put(uri, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
  },
};
